
import PaginationMethod from '@/enums/PaginationMethod';
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';

export default {
  name: 'AppPagination',
  props: {
    pagy: { type: Object, required: true },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    PaginationMethod: () => PaginationMethod,
    ...mapState('window', ['windowService']),
    ...mapState('widget', ['widget'])
  },
  mounted() {
    if (this.widget.pagination_method === PaginationMethod.INFINITE_SCROLL)
      window.addEventListener('scroll', debounce(this.onScroll, 100));
  },
  beforeDestroy() {
    if (this.widget.pagination_method === PaginationMethod.INFINITE_SCROLL)
      window.removeEventListener('scroll', debounce(this.onScroll, 100));
  },
  methods: {
    clickPage(page) {
      this.$emit('click', page);
    },
    appendNextPage(offset) {
      this.$emit('append', { page: this.pagy.next, offset });
    },
    clickSeeMore() {
      this.appendNextPage(
        this.$refs.see_more.getBoundingClientRect().top + window.scrollY
      );
    },
    onScroll() {
      if (!this.$refs.infinite_scroll) return;

      const infiniteScrollOffsetTop =
        this.$refs.infinite_scroll.getBoundingClientRect().top + window.scrollY;
      const nextScrollTop =
        this.windowService.getScrollTop() +
        this.windowService.getWindowHeight() +
        100;

      if (infiniteScrollOffsetTop <= nextScrollTop) this.appendNextPage();
    }
  }
};
